// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export const ConversationIdHttpHeaderName = 'x-ms-conversation-id';
